import React from 'react';
import topBanner from '../Assets/img/topBanner.png';
import { Link } from 'react-router-dom';

const ContactUs = () => {
  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <Link to={`/ShareObservations`} className='btn btn-success btn-sm'>
            <img src={topBanner} alt='Banner' style={{ width: '100%' }} />
          </Link>
        </div>
      </div>

      <div className='container mt-4'>
        <h2>Contact Us</h2>
        <p>
          At <strong>Juice at Home</strong>, we’re here to support your healthy lifestyle. Reach out to us for orders, feedback, or career opportunities.
        </p>

        <h5 className='mt-4'><strong>Sambhajinagar Address:</strong></h5>
        <p>
          Plot no 11, Laxmi Nivas, Keshar Nagri,<br />
          Near Maharana Pratap School, Deolai Road,<br />
          Saratara Parisar, Aurangabad – 431001
        </p>

        <h5 className='mt-4'><strong>Pune Address:</strong></h5>
        <p>
          Floor - 2, Sai Villa, House No – B5, Gat No: 281/2,<br />
          Near RadhaKrishna Apartment, Defence Colony, Kahane Mala,<br />
          Bhangare Nagar, Patil Nagar, Chikhali – Pune – 411062
        </p>

        <h5 className='mt-4'><strong>Support Email:</strong></h5>
        <p>info@juiceathome.me</p>

        <h5 className='mt-4'><strong>Contact Number:</strong></h5>
        <p>+91 9145455055</p>

        {/* <h5 className='mt-4'><strong>Follow us on:</strong></h5>
        <div className="d-flex gap-3 mb-4">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" width="30" alt="Facebook" />
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
            <img src="https://cdn-icons-png.flaticon.com/512/1384/1384060.png" width="30" alt="YouTube" />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            <img src="https://cdn-icons-png.flaticon.com/512/145/145807.png" width="30" alt="LinkedIn" />
          </a>
        </div> */}
      </div>
    </>
  );
};

export default ContactUs;
